module.exports = __webpack_public_path__ + "img/flexible-MT5.213b1aed.png";